var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricSummary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFF8B9D1-F923-42CA-9A9C-3FC83AC0DA25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#666666",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12 L20,12 L20,0 L0,0 L0,12 Z M1,11 L19,11 L19,1 L1,1 L1,11 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "13.1109 3.7289 10.6109 3.7289 10.6109 4.7289 11.4039 4.7289 9.7829 6.3499 9.6499 6.2179 8.9429 5.5099 8.2359 6.2179 6.8889 7.5639 7.5959 8.2709 8.9429 6.9249 9.0749 7.0569 9.7829 7.7649 10.4899 7.0569 12.1109 5.4359 12.1109 6.2289 13.1109 6.2289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricSummary);
export default __webpack_public_path__ + "static/media/MetricSummary.f467024ecb3a2cbdd5740f93af953a63.svg";
export { ForwardRef as ReactComponent };